import { useQuery, useMutation } from '@tanstack/react-query';
import { apiClient } from '@/lib/api';

export function useVerifyToken(token: string) {
  return useQuery({
    queryKey: ['invite-token', token],
    queryFn: () => apiClient.get(`/invitations/verify/${token}`),
    enabled: !!token,
    retry: false,
  });
}

export function useAcceptInvite() {
  return useMutation({
    mutationFn: ({ token, password, acceptedTerms }: { token: string; password: string; acceptedTerms?: boolean }) =>
      apiClient.post(`/invitations/accept/${token}`, { password, acceptedTerms }),
  });
}

export function useDeclineQuote() {
  return useMutation({
    mutationFn: ({
      id,
      token,
      action,
      reason,
    }: {
      id: string;
      token: string;
      action: 'decline' | 'request_changes';
      reason?: string;
    }) => apiClient.post(`/quotes/${id}/decline/${token}`, { action, reason }),
  });
}

export function useQuoteByToken(token: string) {
  return useQuery({
    queryKey: ['quote-by-token', token],
    queryFn: () => apiClient.get(`/quotes/by-token/${token}`),
    enabled: !!token,
    retry: false,
  });
}

export function useSendQuoteInvite() {
  return useMutation({
    mutationFn: (quoteId: string) => apiClient.post(`/quotes/${quoteId}/send`),
  });
}
